import { render, staticRenderFns } from "./WayBillDetail.vue?vue&type=template&id=71fadb90&scoped=true"
import script from "./WayBillDetail.vue?vue&type=script&lang=ts"
export * from "./WayBillDetail.vue?vue&type=script&lang=ts"
import style0 from "./WayBillDetail.vue?vue&type=style&index=0&id=71fadb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fadb90",
  null
  
)

export default component.exports